<template>
	<div>
		<stripe-payment
			v-if="provider === 'stripe'"
			@input="$emit('input', $event)"
			:watchSubmit="watchSubmit"
			:stripePublishableKey="paymentKey"
		/>
	</div>
</template>

<script>
import StripePayment from "./Stripe/StripePayment"
export default {
	name: "payment-provider",
	components: {
		StripePayment
	},
	props: {
		provider: {
			type: String,
			required: true
		},
		paymentKey: {
			type: String,
			required: true
		},
		watchSubmit: {
			type: Number,
			required: false,
			default: 0
		}
	}
}
</script>

<style></style>
